/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// page
import Page from 'material/structure/page/page';
// group
import Group from 'material/group/group';
// copy
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import BodyCopy from 'material/copy/bodycopy/bodycopy';
// ctas
import Link from 'material/ctas/link/link_container';
// styles
// import injectSheet from 'react-jss';
// import styles from 'pages/auth/requestdemo/requestdemo_styles';




/* ========== ~~~~~~~~~~ PAGE : PASSWORD UPDATED : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class PasswordUpdatedPage extends Component {
    render() {
        return(
            <Page name={`passwordreset`}>
                <Group name={`main`}>
                    <Copy>
                        <Title>
                            <h2>Password Updated</h2>
                        </Title>
                        <BodyCopy>
                            <p>{`Successfully updated the password${!!this.props.email ? ` for ${this.props.email}.` : `.`}`}</p>
                            <p>Continue and <Link type={`internal`} action={`auth/signin`} text={`Log In`} color={`primary`} /></p>
                        </BodyCopy>
                    </Copy>
                </Group>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default PasswordUpdatedPage;
// export default injectSheet(styles)(PasswordUpdatedPage);
